import * as hast from 'hast-util-find-and-replace';

const utils = {
  superscript: {
    regex: /\^(\w+)/gi,
    replace: (_, value) => {
      return [
        {
          type: 'element',
          tagName: 'sup',
          properties: {
            class: 'tw:top-[-3px]',
          },
          children: [{ type: 'text', value }],
        },
      ];
    },
  },
  button: {
      regex: /\{([^}]+)}\(([^)^"]+)(?:\s+"([^"]+)")?\)/gi,
      replace: (_, value, href, title) => {
          return [
              {
                  type: 'element',
                  tagName: 'button',
                  properties: {
                      href,
                      value,
                      title,
                      variant: 'primary',
                      class: 'tw:my-2',
                  },
              },
          ];
      }
  },
};

export const rehypeUtil = () => {
  return (tree, _file) => {
    // @ts-ignore
    return hast.findAndReplace(tree, [
      // @ts-ignore
      [utils.superscript.regex, utils.superscript.replace],
      // @ts-ignore
      [utils.button.regex, utils.button.replace],
    ]);
  };
};
